import React from 'react';

function SearchLoading_Main(props) {
    return (
        <div className='search-loading'>
            
                <img src="https://cdn.inflearn.com/assets/brand/brand_logo2.png" alt="" />
            
        </div>
    );
}

export default SearchLoading_Main;